import AuthentificationService from '@/services/authentification'
import i18n from '@/helpers/i18n'
import { USER_LANGUAGE_ENGLISH } from '@/consts/enums'

export default {
  graphQLFetcher
}

function graphQLFetcher(uri, params) {
  return doFetchAndRefreshToken().catch(error => {
    return doFetchAndRefreshToken()
  })

  function doFetchAndRefreshToken() {
    return doFetch().then(async function(response) {
      if (response.status !== 200) {
        await AuthentificationService.renewToken()

        let r2 = await doFetch()
        if (r2.status !== 200) {
          await AuthentificationService.logout()
          throw new Error('Unauthorized')
        }

        return r2
      }

      return response
    })
  }

  async function doFetch() {
    const token = await AuthentificationService.getUserToken()
    if (token !== '') {
      params.headers.authorization = `Bearer ${token}`
    }

    const userLanguage = i18n.userLanguage()
    const acceptLanguageUser = userLanguage == USER_LANGUAGE_ENGLISH ? 'en-CA' : 'fr-CA'
    if (acceptLanguageUser !== '') {
      params.headers['Accept-Language'] = acceptLanguageUser
    }
    return fetch(uri, params)
  }
}
